/*
*  -insert desc here-
*
* Copyright (C) 2018, 2019 Sterilis Solutions, LLC, all rights reserved.
*/
import React from 'react';
import { withTranslation as translate} from "react-i18next";
import {Button, Header, Modal, TransitionablePortal} from "semantic-ui-react";
import AuthService from "../../AuthService";
import SimpleLoader from "../../SimpleLoader";
import {getFileNameFromUrl} from "../../library/helpers";
const Auth = new AuthService();

class DeleteSDImageModal extends React.Component{
  state = {
    modalLoading : false,
    allowModalToBeClosed: true,
  };
  deleteSDImage = () => {
    const {
      SDImage
    } = this.props;
    this.setState({
      modalLoading : true,
      allowModalToBeClosed: false,
    });

    Auth.fetch(`/api/sd-image/${SDImage['id']}/`, {
      method : 'DELETE',
    }).then(data => {
      this.setState({
        modalLoading : false,
        allowModalToBeClosed: true,
      }, () => {
        const SDImageFileName = getFileNameFromUrl(SDImage['upload']);
        this.props.notifySuccess(SDImage['deleted'] ? 'reactivated' : 'archived', SDImageFileName);
        this.props.triggerDeleteSDImageModal(null);
        this.props.preparePage();
      });
    }).catch(err => {
      this.setState({
        modalLoading : false,
        allowModalToBeClosed: true,
      }, () => {
        this.props.notifyFailure();
        this.props.triggerDeleteSDImageModal(null);
      });
    });
  };
  render() {
    const {
      t,
      SDImage
    } = this.props;

    const SDImageFileName = getFileNameFromUrl(SDImage['upload']);

    const inlineStyle = {
      modal : {
        // marginTop: topMargin,
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      textArea : {
        marginTop : '50px',
        width: '400px'
      }
    };
    return (
      <TransitionablePortal
          open={this.props.showDeleteSDImageModal}
          onOpen={() => setTimeout(() => document.body.classList.add('modal-fade-in'), 0)}
          transition={{ animation: 'scale', duration: 500 }}
      >
        <Modal
          style={inlineStyle.modal}
          open={true}
          closeOnDimmerClick={this.state.allowModalToBeClosed}
          closeIcon={<Button className='close-modal-btn grey-btn'>{t('Close')}</Button>}
          size='small'
          onClose={(event) => {
              document.body.classList.remove('modal-fade-in');
              this.props.triggerDeleteSDImageModal(null)
          }}
        >
          <Header>
            <h2>{`${SDImage['deleted'] ? t('Reactivated') : t('Archived')} ${t('SD Image')}`}</h2>
          </Header>
          {this.state.modalLoading ? (
              <SimpleLoader/>
          ) : null}
          <Modal.Content>
            <div className="flex-dir-column short-modal-text center-text">
              {
                SDImage['deleted']  ?
                  <React.Fragment>
                    <p>Are you sure you want to reactivate <strong>{SDImageFileName}</strong>?</p>
                    <p>This action will make <strong>{SDImageFileName}</strong> available for download.</p>
                  </React.Fragment> :
                  <React.Fragment>
                    <p>Are you sure you want to archive <strong>{SDImageFileName}</strong>?</p>
                    <p>This action will make it so that <strong>{SDImageFileName}</strong> will no longer be able available for download.</p>
                  </React.Fragment>
              }
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button className={`ster-btn ${SDImage['deleted'] ? 'green-btn' : 'red-btn'}`}
                    value="Submit"
                    type="submit"
                    id='cycleReportBtn'
                    onClick={this.deleteSDImage}
                    >{`${SDImage['deleted'] ? t('Reactivate') : t('Archive')} ${SDImageFileName}`}</Button>
          </Modal.Actions>
        </Modal>
      </TransitionablePortal>
    )
  }
}

export default translate('translations')(DeleteSDImageModal);
